<template>
  <div>
    <v-container>
      <v-row>
          <v-col lg="6" offset-lg="3">
              <outside-township-form :outside_township="outsideTownship"  @emitOutsideTownshipData="emitData"></outside-township-form>
          </v-col>
      </v-row>
      
    </v-container>
  </div>
</template>

<script>
import OutsideTownshipForm from "@/components/outside_township/OutsideTownshipForm.vue";
import { mapState } from "vuex";
export default {
  created() {
    this.$store.dispatch("OutsideTownship/getEach", this.$route.params.id);
  },
  methods: {
    emitData(data) {
      this.$store.dispatch("OutsideTownship/update", data);
    }
  },
  components: {
    OutsideTownshipForm
  },
   computed: {
    ...mapState("OutsideTownship", ["outsideTownship"]),
    
  },
};
</script>

<style>
</style>